module.exports = __webpack_public_path__ + "img/logo-mcc-masked.8fa7667c.svg";